import React from 'react';
import { Footer , Header} from '../index';
import { Link } from 'react-router-dom';
import './sport.css';
import equipe from '../../asserts/images/equipe.jpg';



function Sport(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
    <Header />
      <div className='containersport'>
        <div className='bgsport'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-160px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'45px'}}className="container-fluid text-white text-center" id='h1club'>Activités sportives</h1>
          <p ><Link className='linkclub' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkclub'
            to="/"> Vie étudiante </Link>  <span>{'>'}</span> <Link className='linkclub'
            to="/">Vie associative</Link><span>{'>'}</span> <Link className='linkclub'
            to="/">Activités sportives </Link></p></div>
         </div>
   
      <div className="containerclub1">
            <div className='CLUB'>
            <div className='IMAGECLUB'>
                <img src={equipe}  alt="..."/>
                </div>
                <div>
                </div>
            </div>
            <div className='PRESCLUB'>
            <span className='NOMCLUB'>Club Football</span><br/><br/>
            Le club de football universitaire est un lieu où les étudiants se réunissent pour jouer au football 
            et renforcer les liens au sein de leur université. Avec un esprit compétitif et une camaraderie forte, 
            le club offre aux étudiants la possibilité de s'entraîner, de jouer des matchs et de représenter 
            fièrement leur école sur le terrain. Que ce soit pour le plaisir de jouer ou pour participer à des 
            tournois interuniversitaires, le club de football universitaire est un élément dynamique de la vie 
            étudiante, offrant une expérience enrichissante aux amateurs de football de tous niveaux.<br/><br/>
     </div>
        </div>
 
     
   
    <Footer />
    </div>

  );
}

export default Sport;
